import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Message } from 'primeng/primeng';
import { MessagesModule } from 'primeng/primeng';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../../employee/service/account/account.service';
import { User } from '../../../employee/class/user';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})

export class RegisterComponent implements OnInit {

    public form: FormGroup;
    // public name: AbstractControl;
    // public lastName: AbstractControl;

    public lastname_1: AbstractControl;
    public lastname_2: AbstractControl;
    public name_1: AbstractControl;
    public name_2: AbstractControl;

    public identification_number: AbstractControl;

    public email: AbstractControl;
    public password: AbstractControl;
    public password_confirmation: AbstractControl;

    public candidate_authorization: AbstractControl;
    public candidate_acceptance: AbstractControl;

    public submitted = false;
    public msgs: Message[] = [];
    public user: User;

    public showRegisterSuccessMsg: boolean;
    public registerSuccessMsg: Message[] = [];

    fieldTextType: boolean = false;

    constructor( fb: FormBuilder, private accountService: AccountService, private router: Router, public translate: TranslateService ) {
        this.form = fb.group({
            // 'name': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
            // 'lastName': ['', Validators.compose([Validators.required, Validators.minLength(4)])],

            'identification_number': ['', Validators.compose([ Validators.required, Validators.minLength(6), Validators.pattern("^[0-9]*$") ])],
            
            'lastname_1': ['', Validators.compose([ Validators.required, Validators.minLength(1),Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$') ])],
            'lastname_2': ['', Validators.compose([ Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$') ])],
            'name_1': ['', Validators.compose([ Validators.required, Validators.minLength(1),Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$') ])],
            'name_2': ['', Validators.compose([ Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]*$') ])],
            
            'email': ['', Validators.compose([ Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$') ])],
            'password': ['', Validators.compose([ Validators.required, Validators.minLength(6) ])],
            'password_confirmation': ['', Validators.compose([ Validators.required, Validators.minLength(6) ])],

            'candidate_authorization': ['', Validators.compose([ Validators.requiredTrue ]) ],
            'candidate_acceptance': ['', Validators.compose([ Validators.requiredTrue ]) ],
        });

        // this.name = this.form.controls['name'];
        // this.lastName = this.form.controls['lastName'];

        this.identification_number = this.form.controls['identification_number'];

        this.lastname_1 = this.form.controls['lastname_1'];
        this.lastname_2 = this.form.controls['lastname_2'];
        this.name_1 = this.form.controls['name_1'];
        this.name_2 = this.form.controls['name_2'];

        this.email = this.form.controls['email'];
        this.password = this.form.controls['password'];
        this.password_confirmation = this.form.controls['password_confirmation'];

        this.candidate_authorization = this.form.controls['candidate_authorization'];
        this.candidate_acceptance = this.form.controls['candidate_acceptance'];
    }

    public onSubmit(values: any): void {
        this.submitted = true;
        values = this.joinNames(values);    
        if (this.form.valid) {
            this.accountService.addUser(values).toPromise().then(
                response => {
                     this.translate.get('registered').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res } );
                        
                        setTimeout(() => {
                            this.router.navigateByUrl('/login-candidate');
                        //     // this.router.navigateByUrl('/login');
                        //     this.showRegisterSuccessMsg = true;
                        //     let successMsg;
                        //     this.translate.get('We will send you an email to'
                        //         + 'confirm that your email address is valid.').subscribe((resMsg: string) => {
                        //         successMsg = resMsg;
                        //     });
                        //     this.registerSuccessMsg.push({severity: 'success', summary: res, detail: successMsg});
                        }, 3000);
                    });
                },
                error => {
                   let errorMsg = '';
                   if ( error.status === 422 || error.status === 409 ) {
                        this.translate.get('The email has already been taken.').subscribe((res: string) => {
                            errorMsg = res;
                        });
                   }
                   if ( error.status === 500 ) {
                        errorMsg = 'Error';
                   }
                   this.msgs = [];
                   this.msgs.push( { severity: 'error', summary: errorMsg  } );
                }
            );
        }
    }

    ngOnInit() {
    }

    // public capitalize(sentence) {
    //     sentence = sentence.toLowerCase();
    //     sentence = sentence.split(' ');

    //     for (var i = 0; i < sentence.length; i++)
    //         sentence[i] = sentence[i][0].toUpperCase() + sentence[i].substring(1);

    //     sentence = sentence.join(' ');

    //     return sentence;
    // }

    public joinNames(values:any){
        values.name_1 = values.name_1.trim().toUpperCase();

        var name = values.name_1;
        
        if (values.name_2) {
            values.name_2 = values.name_2.trim().toUpperCase();
            name +=  ' ' + values.name_2;
        }
        
        values.lastname_1 = values.lastname_1.trim().toUpperCase();
        name += ' ' + values.lastname_1;
        
        if (values.lastname_2){
            values.lastname_2 = values.lastname_2.trim().toUpperCase();
            name += ' ' + values.lastname_2;
        }

        values['name'] = name;
        return values;    
    }

    public gotoLogin() {
        this.router.navigate(['login-candidate']);
    }

    toggleFieldTextType(field_password: number) {
        if(field_password == 1)
            this.fieldTextType = !this.fieldTextType;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/multi-login/components/register/register.component.ts